// AUTO-GENERATED from config/legal-apps.json by scripts/generate-legal-apps.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-legal-apps.mjs` to regenerate; CI fails on drift.
//
// The research services whose terms forbid automation (`automation: firm-confirms` in the catalog), for
// the sign-in window: nothing of Prest0n's signs in to one until an owner of the workspace confirms the
// firm's written permission (docs/PLAN-legal-apps-20260928.md, deliveries 1d and 8; the window asks the
// server). The whole catalog is too large for the first download the sign-in helpers ride, so this is the
// small list; its rules are the full twin's.

export interface FirmConfirmsApp {
  readonly key: string;
  readonly name: string;
  readonly vendor: string;
  readonly matchKeys: readonly string[];
  readonly phrases: readonly (readonly string[])[];
  readonly hosts: readonly string[];
}

export const FIRM_CONFIRMS_APPS: readonly FirmConfirmsApp[] = [
  {"key":"lexisnexis","name":"Lexis+","vendor":"LexisNexis","matchKeys":["lexisnexis","lexis","lexisplus","lexisai","lexisadvance","nexis","nexisuni","nexisai","nexislexis","lexisnexus","lexusnexus","lexesnexus"],"phrases":[["lexis"],["lexis","plus"],["lexis","ai"],["lexisnexis"],["lexis","nexis"],["lexis","advance"],["nexis"],["nexis","uni"],["nexis","ai"],["nexis","lexis"],["lexis","nexus"],["lexus","nexus"],["lexes","nexus"]],"hosts":["lexis.com","lexisnexis.com"]},
  {"key":"westlaw","name":"Westlaw","vendor":"Thomson Reuters","matchKeys":["westlaw","westlawedge","westlawprecision","cocounsel"],"phrases":[["westlaw"],["westlaw","edge"],["westlaw","precision"],["cocounsel"]],"hosts":["westlaw.com"]},
  {"key":"bloomberglaw","name":"Bloomberg Law","vendor":"Bloomberg Industry Group","matchKeys":["bloomberglaw"],"phrases":[["bloomberg","law"],["bloomberglaw"]],"hosts":["bloomberglaw.com"]},
  {"key":"vlex","name":"vLex","vendor":"vLex","matchKeys":["vlex","fastcase","vincentai"],"phrases":[["vlex"],["fastcase"],["vincent","ai"]],"hosts":["vlex.com","fastcase.com"]},
];

function keyOf(name: string): string {
  return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

function wordsOf(text: string): string[] {
  return String(text || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
}

function byHost(urlOrHost: string): FirmConfirmsApp | null {
  const raw = String(urlOrHost || '').trim().toLowerCase();
  if (!raw) return null;
  let host = '';
  try {
    host = new URL(/^[a-z][a-z0-9+.-]*:\/\//.test(raw) ? raw : `https://${raw}`).hostname;
  } catch {
    return null;
  }
  host = host.replace(/\.+$/, '');
  if (!host) return null;
  return FIRM_CONFIRMS_APPS.find((app) => app.hosts.some((h) => host === h || host.endsWith(`.${h}`))) || null;
}

/** The first of them a name names, word by word, in order of first mention. */
function namedIn(text: string): FirmConfirmsApp | null {
  const words = wordsOf(text);
  let best: { at: number; app: FirmConfirmsApp } | null = null;
  for (const app of FIRM_CONFIRMS_APPS) {
    for (const phrase of app.phrases) {
      for (let i = 0; i + phrase.length <= words.length && (!best || i < best.at); i++) {
        if (phrase.every((w, j) => words[i + j] === w)) { best = { at: i, app }; break; }
      }
    }
  }
  return best ? best.app : null;
}

/**
 * The research service a sign-in is for, or null: by the name it is started under (an exact name, the
 * words of a name — "Nexis Lexis" is Lexis+ — or a name that is an address), then by its address.
 */
export function firmConfirmsSignInApp(appName: string, url?: string | null): FirmConfirmsApp | null {
  const name = String(appName || '').trim();
  if (name) {
    const key = keyOf(name);
    const exact = FIRM_CONFIRMS_APPS.find((app) => app.matchKeys.includes(key));
    if (exact) return exact;
    const named = namedIn(name);
    if (named) return named;
    const asAddress = byHost(name);
    if (asAddress) return asAddress;
  }
  return byHost(String(url || ''));
}
